import $ from 'jquery';

var ulSelect = function ($select) {
  const escape = str => {
    const map = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    };
    return str.replace(/[&<>"']/g, m => map[m]);
  };

  $select.hide();

  function renderUlSelect() {
    var $opts = $select.find('option'),
      idDrop = $select.attr('id'),
      items = '',
      html = '',
      buttonType = 'btn-primary';
    idDrop = idDrop ? idDrop + '_dropdown' : '';
    if ($select.data('type')) {
      buttonType = $select.data('type');
    }

    $opts.each(function () {
      items += '<li><a class="item">' + escape($(this).text()) + '</a></li>';
    });

    const selectedOption = $opts.filter('[selected]').length
      ? $opts.filter('[selected]')
      : $opts.first();

    var addDoNotTranslate = idDrop === 'question_dropdown';

    html =
      '<div class="btn-group">' +
      '<button data-toggle="dropdown" class="btn ' +
      buttonType +
      ' dropdown-toggle ss-navigatedown right ' +
      idDrop +
      '" ' +
      (addDoNotTranslate ? 'data-notranslate' : '') +
      ' type="button">' +
      escape(selectedOption.text()) +
      '</button>' +
      '<ul role="menu" class="dropdown-menu">' +
      items +
      '</ul>' +
      '</div>';

    return $(html)
      .find('li .item')
      .click(function (e) {
        // You can attach more events...
        var $this = $(this);
        e.preventDefault();
        $this.parents('.btn-group').find('.dropdown-toggle').text($this.text());
        $opts.eq($this.parent().index()).prop('selected', true).change();
        $select[0].dispatchEvent(new Event('change', { bubbles: true })); // trigger react onChange callback
      })
      .end()
      .insertAfter($select);
  }

  var ulSelectEl = renderUlSelect();

  $select.bind('DOMSubtreeModified', function () {
    ulSelectEl.remove();
    ulSelectEl = renderUlSelect();
  });

  return ulSelectEl;
};

window.ulSelect = ulSelect;

var wrapperFunction = function (type) {
  return function (_index, input) {
    var $input = $(input);
    if ($input.attr('type') == type && !$input.hasClass('js-manual-style')) {
      $input.addClass(type + '-custom');
      $("label[for='" + $input.attr('id') + "']").addClass(
        type + '-custom-label',
      );
    }
  };
};

window.connectCustomUi = window.connectCustomUi || {};
window.connectCustomUi.setup = function () {
  $(':checkbox:not(.unstyled)')
    .filter(":not([data-toggle='switch'])")
    .each(wrapperFunction('checkbox'));
  $(':radio:not(.unstyled :radio)').each(wrapperFunction('radio'));
  if ($('[data-toggle="switch"]:not(.unstyled)').length) {
    $('[data-toggle="switch"]:not(.unstyled)').bootstrapSwitch();
  }

  $('select:not(.unstyled)').each(function (_index, select) {
    ulSelect($(select));
  });

  $('body').on('click', 'button.dropdown-toggle', function () {
    var $parent = $(this).parent();
    $parent.toggleClass('open'); //makes above select work
    if (!$parent.is('.open')) {
      $(this).trigger('close-dropdown');
    }
  });
};

$(function () {
  window.connectCustomUi.setup();
});
